<template>
  <div class="search-widget pa-4">
    <div class="search-heading font-display">
      <span class="accent-dot" />Suche
    </div>
    <v-text-field
      v-model="trainNumber"
      label="Zugnummer"
      placeholder="z.B. 70 (für ICE 70)"
      prepend-inner-icon="mdi-train"
      append-inner-icon="mdi-magnify"
      @click:append-inner="navigateToTrain(trainNumber)"
      v-on:keydown.enter="navigateToTrain(trainNumber)"
      hide-details="auto"
      class="mb-3"
    />
    <v-text-field
      v-model="vehicle"
      label="Triebfahrzeug"
      placeholder="z.B. 9001 (f. Tz 9001)"
      prepend-inner-icon="mdi-tram-side"
      append-inner-icon="mdi-magnify"
      @click:append-inner="navigateToVehicle(vehicle)"
      v-on:keydown.enter="navigateToVehicle(vehicle)"
      hide-details="auto"
      class="mb-3"
    />
    <v-select
      v-model="searchRange"
      label="Zeitraum"
      prepend-inner-icon="mdi-calendar"
      :items="dateRangeItems"
      item-title="title"
      item-value="days"
      hide-details="auto"
    />
    <v-btn
      variant="tonal"
      color="primary"
      block
      class="mt-3"
      prepend-icon="mdi-map-marker-path"
      :append-icon="oidcIsAuthenticated ? undefined : 'mdi-lock'"
      :to="{ name: 'connections' }"
    >
      Verbindung suchen
    </v-btn>
    <AnonymousNotice class="mt-3" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AnonymousNotice from '@/components/AnonymousNotice.vue'
import SearchNavigationMixin from '@/mixins/SearchNavigationMixin'

const DATE_RANGES = [
  { title: "7 Tage", days: 7 },
  { title: "30 Tage", days: 30 },
  { title: "1 Jahr", days: 365 },
  { title: "unbegrenzt", days: -1 },
];

export default {
  name: 'SearchWidget',

  mixins: [SearchNavigationMixin],

  components: {
    AnonymousNotice,
  },

  computed: {
    // The button keeps leading to the page while signed out — it is the page that explains why
    // the search is shut — so the lock is the only advance warning the button can give.
    ...mapGetters('oidcStore', ['oidcIsAuthenticated']),

    searchRange: {
      get () {
        return this.$store.state.search.range
      },
      set (value) {
        this.$store.commit('updateSearchRange', value)
      }
    },

    // Ranges beyond the anonymous window are shown disabled rather than hidden: with a 7-day
    // cap, filtering them out would leave a one-item dropdown and no hint that signing in
    // unlocks more.
    dateRangeItems: function() {
      const cap = this.$store.state.anonymousHistoryDays
      return DATE_RANGES.map(range => {
        const locked = cap != null && (range.days < 0 || range.days > cap)
        return {
          ...range,
          props: locked ? { disabled: true, appendIcon: 'mdi-lock' } : {},
        }
      })
    },
  },

  data: () => ({
    trainNumber: '',
    vehicle: '',
  }),
};
</script>

<style scoped>
.search-heading {
  display: flex;
  align-items: center;
  gap: 9px;
  font-weight: 700;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 16px;
}
.accent-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgb(var(--v-theme-accent));
}
</style>
